import { useState } from 'react';
import { history } from 'umi';
import { IconButton } from '@material-ui/core';
import { useTheme, Tooltip } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import DataTableNativeML from '@/components/DataTableNativeML';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import styles from './TablePage.less?modules';

const TablePage = (props) => {
  const theme = useTheme();
  const {
    pagination,
    total,
    loading,
    tableData,
    setPageData,
    sortField,
    setSortField = () => {},
    setSort,
  } = props || {};
  const [visitTimeSort, setVisitTimeSort] = useState(true);
  const [bookPageNumSort, setBookPageNumSort] = useState(true);
  const [signNumSort, setSignNumSort] = useState(true);
  const [visitTimeAveSort, setVisitTimeAveSort] = useState(true);
  const handleDetail = (record) => {
    console.log('record', record);
    history.push({
      pathname: '/data/user_behavior/detail',
      query: {
        id: record.userid,
      },
    });
  };

  // useMemo(() => {
  //   setSort(visitTimeSort);
  // }, [visitTimeSort]);
  // useMemo(() => {
  //   setSort(bookPageNumSort);
  // }, [bookPageNumSort]);
  // useMemo(() => {
  //   setSort(signNumSort);
  // }, [signNumSort]);
  // useMemo(() => {
  //   setSort(visitTimeAveSort);
  // }, [visitTimeAveSort]);
  const showTooltipTitle = (title, tip) => {
    return (
      <>
        {title}
        <Tooltip
          title={<div style={{ fontSize: '14px' }}>{tip}</div>}
          placement="top"
          arrow
        >
          <ErrorOutlineIcon
            sx={{
              width: '14px',
              height: '14px',
              color: '#1565C0',
              marginBottom: '10px',
            }}
          />
        </Tooltip>
      </>
    );
  };

  const columns = [
    {
      align: 'center',
      title: '编号',
      id: 'code',
      width: 80,
    },
    {
      title: '用户名',
      align: 'center',
      id: 'userName',
      key: 'userName',
      width: 150,
    },
    // {
    //   title: '账号',
    //   align: 'center',
    //   id: 'userAccount',
    //   key: 'userAccount',
    //   width: 150,
    // },
    {
      title: '权限组',
      id: 'rolePermitted',
      key: 'rolePermitted',
      width: 180,
      align: 'center',
      render: (recor) => {
        return recor.rolePermitted;
      },
    },
    {
      title: '最近一次访问时间',
      id: 'visitTime',
      key: 'visitTime',
      align: 'center',
      width: 180,
      fieldSort: visitTimeSort,
      // setSort: setVisitTimeSort,
      callback: (fieldSort, sortKey) => {
        setVisitTimeSort(sortKey);
        setSortField(fieldSort);
        setSort(sortKey);
      },
      isSort: true,
    },
    {
      title: showTooltipTitle(
        '页面访问数',
        // '新增会员注册数量',
        '用户访问的页面总数',
        'registerCount',
      ),
      id: 'bookPageNum',
      key: 'bookPageNum',
      width: 140,
      align: 'center',
      fieldSort: bookPageNumSort,
      // setSort: setBookPageNumSort,
      callback: (fieldSort, sortKey) => {
        setBookPageNumSort(sortKey);
        setSortField(fieldSort);
        setSort(sortKey);
      },
      isSort: true,
    },
    {
      title: '登陆次数',
      id: 'signNum',
      key: 'signNum',
      width: 120,
      align: 'center',
      fieldSort: signNumSort,
      callback: (fieldSort, sortKey) => {
        setSignNumSort(sortKey);
        setSortField(fieldSort);
        setSort(sortKey);
      },
      // setSort: setSignNumSort,
      isSort: true,
    },
    {
      title: showTooltipTitle(
        '平均访问时长',
        // '新增会员注册数量',
        '每个页面的访问时间总和/页面访问数',
        'registerCount',
      ),
      id: 'visitTimeAve',
      key: 'visitTimeAve',
      width: 140,
      align: 'center',
      render: (recor) => {
        return recor.visitTimeAve;
      },
      fieldSort: visitTimeAveSort,
      // setSort: setVisitTimeAveSort,
      callback: (fieldSort, sortKey) => {
        setVisitTimeAveSort(sortKey);
        setSortField(fieldSort);
        setSort(sortKey);
      },
      isSort: true,
    },
    {
      title: '操作',
      width: 100,
      align: 'center',
      render: (recor) => {
        return (
          <div align="center" className={styles.handle_btn}>
            <ButtonTip title="详情">
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                className=""
                onClick={() => handleDetail(recor)}
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={theme.palette.primary.main}
                  // fill={'#1B60AD'}
                  className="preview"
                />
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <DataTableNativeML
        loading={loading}
        paging={true}
        total={total}
        columns={columns}
        page={pagination}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={tableData}
        columnKey="id"
        sortField={sortField}
        setSortField={setSortField}
        sortType={'multiline'}
      ></DataTableNativeML>
    </>
  );
};
export default TablePage;
